import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { patchInvestigation } from "../../../../../apis";
import { InvestigationSectionHeader } from "../components/InvestigationSectionHeader";
import { InvestigationAdvertisement } from "../components/InvestigationAdvertisement";
import { Separator } from "../components";
import { InvolvedInfo } from "./Modals/InvolvedInfo";
import { AddInvolved } from "./AddInvolved";
import { InvolvedTypes } from "./InvolvedTypes";
import { useInvolveds } from "./hooks/useInvolveds";
import { useConstants } from "../Main/useConstants";

const initInvolveds = {
  victim: [],
  witness: [],
  offender: [],
  // accomplice: [], // Comentado temporalmente
}

// Componente de involucrados 
export const Involved = ({
  investigation,
  setInvestigation,
  justView,
  handleSelectedSection,
}) => {

  const [t] = useTranslation("investigation");
  const { enums, functions: { askUpdateInvestigationRedux } } = useConstants();


  const [involveds, setInvolveds] = useState(initInvolveds);
  const [isAdding, setIsAdding] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const [selectedInvolved, setSelectedInvolved] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const haveInvolveds = useMemo(() => {
    return Object.values(involveds).some(involved => involved.length > 0);
  }, [involveds]);

  useEffect(() => {
    if (investigation.involved) {
      setInvolveds(investigation.involved);
    } else {
      setInvolveds(initInvolveds);
    }
  }, [investigation.involved]);

  const handleSaveInvolveds = async (newInvolveds) => {

    const objToSave = {
      folder: {
        involved: newInvolveds,
      },
    };

    try {
      await patchInvestigation(investigation.alias, objToSave);
      setInvestigation({ ...investigation, involved: newInvolveds, });
      askUpdateInvestigationRedux({ ...investigation, involved: newInvolveds });
      setIsAdding(false);
    } catch (error) {
      console.error(error);
    }
  };

  if (!haveInvolveds && justView) return null;

  return (
    <>
      <InvolvedInfo // MODAL
        open={showDrawer}
        onClose={() => setShowDrawer(false)}
        selectedInvolved={selectedInvolved}
        setSelectedInvolved={setSelectedInvolved}
        handleSaveInvolveds={handleSaveInvolveds}
        // involvedsInInvestigation={involvedsInInvestigation}
        involvedsInInvestigation={involveds}
        isLoading={isLoading}
        justView={justView}
      />
      
    <Box className="dyTheme1">

        {
          !isAdding && !justView &&
          <InvestigationSectionHeader
            text={t("involved.add_to_report")}
            buttonText={t("involved.add")}
            buttonIcon="outline_user_circle_add"
            onClick={() => setIsAdding(true)}
            type="involved"
          />
        }

        {
          !haveInvolveds && !isAdding && !justView &&
          <InvestigationAdvertisement 
            title={t("involved.no_registered")}
            description={t("involved.review_and_include")}
          />
        }

      {
        haveInvolveds && justView &&
        <Separator 
          text={t("sections.involved")}
          icon="outline_profile_2_user" 
          iconButton="outline_edit"
          onClick={() => handleSelectedSection(enums.sections.involveds)}
          sx={{ marginBottom: 1.5 }}
        />
      }

        {
          haveInvolveds && !isAdding &&
          <InvolvedTypes
            involvedsInInvestigation={involveds}
            setSelectedInvolved={setSelectedInvolved}
            setShowDrawer={setShowDrawer}
            handleSaveInvolveds={handleSaveInvolveds}
            justView={justView}
          />
        }

        {
          isAdding &&
          <AddInvolved
            handleSaveInvolveds={handleSaveInvolveds}
            // involvedsInInvestigation={involvedsInInvestigation}
            involvedsInInvestigation={involveds}
            setIsAdding={setIsAdding}
          />
        } 

      </Box>
    </>
  );
};